const NOTIF_KEY = 'careguard_notif_enabled';

export function isNotificationsSupported() {
  return 'Notification' in window;
}

export function getNotificationPermission() {
  if (!isNotificationsSupported()) return 'unsupported';
  return Notification.permission;
}

export async function requestNotificationPermission() {
  if (!isNotificationsSupported()) return 'unsupported';
  const result = await Notification.requestPermission();
  if (result === 'granted') {
    localStorage.setItem(NOTIF_KEY, 'true');
  }
  return result;
}

export function isNotificationsEnabled() {
  return localStorage.getItem(NOTIF_KEY) === 'true' && getNotificationPermission() === 'granted';
}

export function showNotification(title, options = {}) {
  if (!isNotificationsEnabled()) return;
  try {
    new Notification(title, {
      icon: '/careguard-logo.png',
      badge: '/careguard-logo.png',
      ...options
    });
  } catch (e) {
    console.warn('Notification failed:', e);
  }
}

export function notifyCheckinDue(userName) {
  showNotification('CareGuard - Check-in Due', {
    body: `${userName}, your wellness check-in is due. Please check in now.`,
    tag: 'checkin-due',
    requireInteraction: true
  });
}

export function notifyCheckinOverdue(userName) {
  showNotification('CareGuard - Check-in Overdue!', {
    body: `${userName}, your check-in is OVERDUE. Please check in immediately.`,
    tag: 'checkin-overdue',
    requireInteraction: true
  });
}

export function notifyTimerDone() {
  showNotification('CareGuard - Timer Finished', {
    body: 'Your countdown timer has completed!',
    tag: 'timer-done'
  });
}

export function notifyAlarm(label) {
  showNotification('CareGuard - Alarm', {
    body: label || 'Your alarm is ringing!',
    tag: 'alarm',
    requireInteraction: true
  });
}

export function notifyEventReminder(eventTitle, minutesBefore) {
  showNotification('CareGuard - Event Reminder', {
    body: `"${eventTitle}" starts in ${minutesBefore} minutes`,
    tag: `event-${eventTitle}`
  });
}
